import axios from "axios";

export const listEdges = (cursor, limit, success, failure) => {
    let url = "/api/v1/edge/list?limit=" + limit;

    if (cursor) {
        url += "&cursor=" + cursor;
    }

    axios.get(url)
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const createEdge = (edge, success, failure) => {
    const url = `/api/v1/edge/`;

    axios.post(url, {
        sourceNodeId: edge.sourceNodeId,
        targetNodeId: edge.targetNodeId,
        category: edge.category,
        label: edge.label,
        metadata: edge.metadata,
    })
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const updateEdge = (edgeId, edge, success, failure) => {
    const url = `/api/v1/edge/${edgeId}/`;

    axios.put(url, {
        sourceNodeId: edge.sourceNodeId,
        targetNodeId: edge.targetNodeId,
        category: edge.category,
        label: edge.label,
        metadata: edge.metadata,
    })
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(err => {
        failure(err);
    });
};

export const deleteEdge = (edgeId, success, failure) => {
    const url = `/api/v1/edge/${edgeId}/`;

    axios.delete(url)
    .then(response => {
        success(edgeId);
    })
    .catch(err => {
        failure(err);
    });
};
